<template>
  <div class="container-fluid mt-4">
    <b-breadcrumb :items="breadcrumb" />
    <div>
      <b-card-group
        id="deck"
        deck
      >
        <b-card
          class="card"
          header-tag="header"
          title="Provision a new project"
        >
          <h6
            slot="header"
            class="mb-0"
          >
            Project Provision
          </h6>
          <p class="card-text">
            Provision a new project in Visual Studio Team Service, Azure Resoure Group and Kubernetes namespace.
          </p>
          <b-button
            class="card-button"
            to="/new-project"
            variant="primary"
          >
            Go
          </b-button>
        </b-card>
        <b-card
          class="card"
          title="Review projects"
          header-tag="header"
        >
          <h6
            slot="header"
            class="mb-0"
          >
            Project Status
          </h6>
          <p class="card-text">
            Review or edit your project details and status.
          </p>
          <b-button
            bottom
            class="card-button"
            to="/projects"
            variant="primary"
          >
            Go
          </b-button>
        </b-card>
        <div />
      </b-card-group>
      <b-card-group columns>
        <b-card
          header-tag="header"
          title="Resources"
        >
          <h6
            slot="header"
            class="mb-0"
          >
            Helpful Resources
          </h6>
          <div>
            <strong>Internal Resources</strong>
            <div>
              <b-link
                v-b-tooltip.hover
                class="card-text"
                target="_blank"
                href="https://batchat.motorolasolutions.com/home/ls/community/cloud-infrastructure-engineering-software-enterprise"
                title="CIE on MSI Interactive portal (was Converge) with a bunch of articles covering everything!"
              >
                Cloud Infrastructure Engineering (CIE) on BatChat
              </b-link>
            </div>
            <div>
              <b-link
                v-b-tooltip.hover
                class="card-text"
                target="_blank"
                href="https://docs.google.com/document/d/1ZZ6qraqOpFO-miepDKMpjI68FOuxeLCIQOvpJPz41Eg/edit#heading=h.ofdptp1eb7yo"
                title="Azure Devops Intro Guide that provides development samples."
              >
                Cloud Infrastructure Developer’s Guide <strong>101</strong>
              </b-link>
            </div>
            <div>
              <b-link
                v-b-tooltip.hover
                class="card-text"
                target="_blank"
                href="https://docs.google.com/document/d/16T7KhfT1wnJdlKczwGKTMtu9Y7rOF1NkLyuJLuvzaWw/edit"
                title="Azure Devops Advanced Guide that covers configuration, deployment,
                      CI/CD and Kubernetes."
              >
                Cloud Infrastructure Developer’s Guide <strong>201</strong>
              </b-link>
            </div>
          </div>
          <div id="azure">
            <strong>Azure Resources</strong>
            <div>
              <b-link
                v-b-tooltip.hover
                class="card-text"
                target="_blank"
                href="https://docs.microsoft.com/en-us/azure/azure-resource-manager/resource-group-overview"
                title="Describes how to use Azure Resource Manager for deployment, management, and access control of resources on Azure."
              >
                Azure Resource Manager overview
              </b-link>
            </div>
            <div>
              <b-link
                v-b-tooltip.hover
                class="card-text"
                target="_blank"
                href="https://azure.microsoft.com/en-us/resources/"
                title="New to the cloud? Learning about Azure? The Azure Cloud Resource Center has whitepapers,
                analyst reports, and on-demand webinars to help you learn the basics!"
              >
                Azure resources
              </b-link>
            </div>
          </div>
          <div id="ado">
            <strong>Azure Devops (ADO)</strong>
            <div>
              <b-link
                v-b-tooltip.hover
                class="card-text"
                target="_blank"
                href="https://docs.microsoft.com/en-us/azure/devops/index?view=azure-devops"
                title="Azure DevOps documentation: Collaborate on software development through version control,
                work tracking, and continuous integration and delivery (CI/CD) with Azure DevOps."
              >
                Azure Devops Documentation
              </b-link>
            </div>
          </div>
        </b-card>
        <b-card
          id="logo-card"
          border-variant="light"
        >
          <img
            id="logo"
            src="../../static/img/msi.png"
            alt="Responsive image"
          >
        </b-card>
      </b-card-group>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';

Vue.use(BootstrapVue);

export default {
  data() {
    return {
      breadcrumb: [
        {
          text: 'Home',
          active: true,
        },
      ],
    };
  },
};
</script>

<style>
#azure,
#ado {
  margin-top: 2%;
}

#deck {
  margin-bottom: 2%;
}

.card-button {
  width: 100px;
}

#logo-card {
  border-width: 0;
}

#logo {
  width: 80%;
  height: 80%;
  margin-top: 80%;
  margin-left: 10%;
}

.col-centered {
  float: none;
  margin: 0 auto;
}
</style>
